// extracted by mini-css-extract-plugin
export var arbiterSwatch = "_2r-3";
export var dialog = "_2r-0";
export var divClassnameSwatch = "_2r-8";
export var flexSwatch = "_2r-4";
export var header = "_2r-1";
export var styleAttributeSwatch = "_2r-7";
export var swatch = "_2r-2";
export var textHeaderSwatch = "_2r-5";
export var webSwatch = "_2r-6";